<template>
  <div class="shop-container">
    <div class="t">
      <div class="tl">
        <div class="tl-img">
          <i class="icon iconfont iconsuccess"></i>
        </div>
        <div class="tl-info">
          <!-- <h3>{{$t('addedToCartSuccessfully')}}!</h3> -->
          <h3>Added to Cart</h3>
        </div>


        <div class="tl-info info2">
          <span class="name">{{goodsName}}</span>
          <h4>subtotal({{buyNum || 0}} item): <span>${{totalPrice}}</span> </h4>
        </div>

      </div>
      <div class="tr">
        <div class="tr-btn back" @click="$router.go(-1)">{{$t('goBack')}}</div>
        <div class="tr-btn go"><router-link to="cart">{{$t('toPay')}}</router-link></div>
      </div>
    </div>
    <div class="b" >
      <div class="title">
        <h2 v-if="goodsList.length">{{$t('othersHaveBoughtThem')}}</h2>
        <h2 v-else>{{$t('goodsPicke')}}</h2>
        <ProductRowFive :list="goodsList" v-if="goodsList.length"></ProductRowFive>
      </div>
    </div>
  </div>
</template>

<script>
import ProductRowFive from "@/components/layout/ProductRowFive.vue";
export default {
  name: "BuySuccess",
  components: {ProductRowFive},
  props: {},
  data() {
    return {
      goodsName:'',
      goodsList:[],
      goodsInfo: {},
      buyNum:0,
      price:0,
    };
  },
  watch: {},
  computed: {
    totalPrice() {
      return (this.buyNum * Number(this.price)).toFixed(2)
    }
  },
  methods: {
    getPickGoods(){
      let data={
        page:1,
        limit:10
      }
      this.$api.getPickGoods(data).then(res=>{
        if(res.status){
          this.goodsList=res.data.list;
        }
      })
    },
  },
  created() {},
  mounted() {
    this.goodsName = this.$route.query.goodsName;
    this.buyNum =  this.$route.query.buyNum;
    this.price =  this.$route.query.price;
    this.getPickGoods()
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.shop-container {
  padding-top: 20px;
}
.t {
  margin-bottom: 26px;
  padding: 0 0 28px 0;
  height: 68px;
  border-bottom: 1px solid #e0e0e0;
  .tl {
    .tl-img {
      float: left;
      width: 64px;
      height: 64px;
      margin-right: 20px;
      .icon {
        font-size: 64px;
        color: #84c54d;
      }
    }
    .tl-info {
      float: left;
      &.info2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 0 10px 20px;
        .name {
          font-size: 16px;
        }
        h4 {
          margin-top: 10px;
          font-weight: bold;
          span {
            color: #e7442f;
          }
        }
      }
      h3 {
        margin: 0;
        color: #424242;
        font-size: 22px;
        font-weight: normal;
        margin: 10px 0;
        padding-top: 10px;
      }
      span {
        font-size: 14px;
        color: #757575;
      }
    }
  }
  .tr {
    float: right;
    .tr-btn {
      display: inline-block;
      width: 180px;
      margin-left: 12px;
      margin-top: 5px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
      &.back {
        border: 1px solid #b0b0b0;
        color: #757575;
        &:hover {
          background: #fff;
        }
      }
      &.go {
        background: $theme-color;
        color: #fff;
        border: 1px solid $theme-color;
      }
    }
  }
}
.b {
  .title {
    h2 {
      text-align: center;
      height: 50px;
      font-size: 28px;
      font-weight: 400;
      color: #757575;
      margin-bottom:20px;
    }
  }
}

.imgs-wrap{
  img {
    width: 60px;
    height: 60px;
  }
}
</style>